module.exports = __webpack_public_path__ + "static/img/4814_phase_function_Paper_Points.f1dad28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4814_phase_function_Paper_Points.png
// module id = +ydR
// module chunks = 0